import { Button, Flex, Switch, TableColumnsType, Tooltip } from 'antd'
import React from 'react'

import { NormalStatus } from '@/constants/normal-status'

export interface TableData {
  key: number;
  name: string;
  description: string;
  users: string[];
  status: NormalStatus;
  disabled: boolean;
}

export type TableDataHandle = (record: TableData, index: number) => void;

export interface TableDataItemOptions {
  onStatusChange?: (
    value: string | string[] | boolean | undefined,
    record: TableData,
    index: number
  ) => void;
  onSetPermissionsClick?: TableDataHandle;
  onEditClick?: TableDataHandle;
  onDeleteClick?: TableDataHandle;
}

export default function useRoleSettingsColumns(
  options: TableDataItemOptions,
): TableColumnsType<TableData> {
  const { onStatusChange, onSetPermissionsClick, onEditClick, onDeleteClick } =
    options
  return [
    {
      title: 'Role',
      dataIndex: 'name',
      ellipsis: {
        showTitle: false,
      },
      width: 200,
      render(value: string) {
        return (
          <Tooltip placement="top" title={value}>
            {value}
          </Tooltip>
        )
      },
    },
    {
      title: 'Description',
      dataIndex: 'description',
      ellipsis: {
        showTitle: false,
      },
      render(value: string) {
        return (
          <Tooltip placement="top" title={value}>
            {value}
          </Tooltip>
        )
      },
    },
    {
      title: 'Users',
      dataIndex: 'users',
      ellipsis: {
        showTitle: false,
      },
      render(value: string[]) {
        return (
          <Tooltip placement="top" title={value.join(', ')}>
            {value.join(', ')}
          </Tooltip>
        )
      },
    },
    {
      title: 'Status',
      dataIndex: 'status',
      width: 100,
      render(value: NormalStatus, record, index) {
        return (
          <Switch
            disabled={record.disabled}
            checked={value === NormalStatus.Activated}
            onChange={(value) =>
              onStatusChange?.(
                value ? NormalStatus.Activated : NormalStatus.Deactivated,
                record,
                index,
              )
            }
          />
        )
      },
    },
    {
      title: 'Operations',
      width: 340,
      render(_, record, index) {
        return (
          <Flex gap={0} align="center">
            <Button
              disabled={record.disabled}
              type="link"
              onClick={() => onSetPermissionsClick?.(record, index)}
            >
              Set permissions
            </Button>
            |
            <Button
              disabled={record.disabled}
              type="link"
              onClick={() => onEditClick?.(record, index)}
            >
              Edit
            </Button>
            |
            <Button
              disabled={record.disabled}
              type="link"
              danger
              onClick={() => onDeleteClick?.(record, index)}
            >
              Delete
            </Button>
          </Flex>
        )
      },
    },
  ]
}
